import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

const getItemStyle = (
  isDragging,
  draggableStyle,
  selectedAccount,
  accountId,
) => ({
  userSelect: 'none',
  display: 'inline-flex',
  width: '100%',
  padding: '10px',
  background: isDragging
    ? 'lightgreen'
    : selectedAccount === accountId
    ? 'lightgrey'
    : 'white',
  ...draggableStyle,
});

const getListStyle = (isDraggingOver, length) => ({
  background: isDraggingOver ? 'lightblue' : 'white',
  padding: length === 0 ? 8 : 0,
});

const ServiceCommandUnit = ({ subItems, type, selectedAccount, handleToggle, groupId }) => {
  const accountClick = (e, accountId) => {
    handleToggle(e, groupId, type, accountId);
  };

  return (
    <Droppable droppableId={type.toString()} type="droppableSubItem">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          style={getListStyle(snapshot.isDraggingOver, subItems.length)}
        >
          {subItems.map((item, index) => (
            <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
              {(provided, snapshot) => (
                <div
                  style={{
                    display: 'flex',
                    borderTop: '1px solid rgba(224, 224, 224, 1)',
                    backgroundColor: selectedAccount === item.id ? 'lightgrey' : 'white',
                    height: 50,
                    alignItems: 'center',
                  }}
                  onClick={(e) => accountClick(e, item.id)}
                >
                  <span
                    {...provided.dragHandleProps}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 60,
                    }}
                  >
                    <DragIndicatorIcon />
                  </span>
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={getItemStyle(
                      snapshot.isDragging,
                      provided.draggableProps.style,
                      selectedAccount,
                      item.id,
                    )}
                  >
                    {item.content}
                  </div>
                  {provided.placeholder}
                </div>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default ServiceCommandUnit;
